import { getSocket } from '@src/App';

export default async (gameId: string, color: string) => {
  try {
    getSocket().emit('chooseColor', { gameId, color });
  } catch (e) {
    console.log(e);
  }
};
